module.exports = __webpack_public_path__ + "static/media/md-school.d3f10a76.svg";